import moment from 'moment'

const format = 'DD.MM.YYYY'
const biggestJavascriptFloat = moment(8.64E+15).format(format)
const leastJavascriptFloat = moment(-8.64E+15).format(format)

/**
 * @member {moment.Moment} from
 * @member {moment.Moment} to
 */
export default class PeriodDto {
  from
  to

  /**
   * @param {moment.Moment|null} from
   * @param {moment.Moment|null} to
   */
  constructor({
    from,
    to
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    from = moment(from ?? leastJavascriptFloat, format)
    to = moment(to ?? biggestJavascriptFloat, format)

    from = from.isValid() ? from : moment(leastJavascriptFloat, format)
    to = to.isValid() ? to : moment(biggestJavascriptFloat, format)

    Object.defineProperty(this, 'from', Object.assign({ value: from }, properties))
    Object.defineProperty(this, 'to', Object.assign({ value: to }, properties))

    Object.freeze(this)
  }
}
